module.exports = __webpack_public_path__ + "img/montant-caisse.7dc57f93.png";